import { Actions } from "../../constants/actionTypes";
import { apiRequest } from "../../../Utils/axiosApi";
import { put, call } from "redux-saga/effects";

export function* fetchAllUsers() {
  try {
    const result = yield call(apiRequest, {
      url: "/users/allUsers",
      method: "GET",
    });

    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_ALL_USERS, data: result.data });
    } else {
      yield put({ type: Actions.SET_ALL_USERS, data: null });
    }
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}
export function* fetchUserDetails() {
  try {
    const result = yield call(apiRequest, {
      url: "/users/userDetails",
      method: "GET",
    });
    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_USER_DETAILS, data: result.data });
    } else {
      yield put({ type: Actions.SET_USER_DETAILS, data: null });
    }
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* getOrgInvitationsForUser() {
  try {
    const result = yield call(apiRequest, {
      url: "/users/newOrgInvitations",
      method: "GET",
    });

    if (result.isApiSuccessful) {
      // Ensure data is always an array
      const dataArray = Array.isArray(result.data) ? result.data : [];
      yield put({
        type: Actions.SET_ORG_USER_INVITATIONS,
        userInvitations: { data: dataArray, isApiSuccessful: true },
      });
    } else {
      yield put({
        type: Actions.SET_ORG_USER_INVITATIONS,
        userInvitations: { data: [], isApiSuccessful: false },
      });
    }
    return result;
  } catch (err) {
    yield put({
      type: Actions.SET_ORG_USER_INVITATIONS,
      userInvitations: { data: [], isApiSuccessful: false },
    });
    return { isApiSuccessful: false, data: err };
  }
}

export function* updateOrgUsersInvitation(invitation, status) {
  try {
    const result = yield call(apiRequest, {
      url: "/users/updateInvitation",
      method: "POST",
      data: {
        orgId: invitation.orgId,
        newStatus: status,
      },
    });

    yield call(getOrgInvitationsForUser);

    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiFetchUsersNotifications(page) {
  try {
    const result = yield call(apiRequest, {
      url: `users/notifications?page=${page}`,
      method: "GET",
    });
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: false };
  }
}

export function* apiMarkNotificationRead(selectedNotificationBodies) {
  try {
    const result = yield call(apiRequest, {
      url: `users/notification/markread`,
      method: "POST",
      data: selectedNotificationBodies,
    });
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: false };
  }
}

export function* apiUpdateDetails(details) {
  try {
    const result = yield call(apiRequest, {
      url: "/users/updateUserDetails",
      method: "PUT",
      data: {
        userName: details.userName,
        phoneNumber: details.phoneNumber,
        avatarId: details.avatarId,
        country: details.country,
      },
    });
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiUsers(action) {
  try {
    const result = yield call(apiRequest, {
      url: "/users",
      method: "POST",
      data: action.data,
    });
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiCheckUserPlan(action) {
  try {
    const result = yield call(apiRequest, {
      url: "/users/doesUserHasPlan",
      method: "GET",
    });
    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_CHECK_USER_HAS_PLAN, data: result.data });
      if (action.meta?.onSuccess) {
        yield call(action.meta.onSuccess, result.data);
      }
    } else {
      yield put({ type: Actions.SET_CHECK_USER_HAS_PLAN, data: null });
      if (action.meta?.onError) {
        yield call(action.meta.onError, result.data);
      }
    }
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiIsUserPartOfOrg(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/users/isUserPartOfOrg?email=${action.data.email}&orgId=${action.data.orgId}`,
      method: "GET",
    });
    if (result.isApiSuccessful) {
      yield put({ type: Actions.SET_IS_USER_PART_OF_ORG, data: result.data });
    } else {
      yield put({ type: Actions.SET_IS_USER_PART_OF_ORG, data: null });
    }
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}

export function* apiGetThemeDetails(action) {
  try {
    const result = yield call(apiRequest, {
      url: `/users/updateTheme?theme=${action.data.theme}`,
      method: "POST",
    });
    if (result.isApiSuccessful) {
      yield put({ type: Actions.API_USER_DETAILS, data: result.data });
    } else {
      yield put({ type: Actions.API_USER_DETAILS, data: null });
    }
    return result;
  } catch (err) {
    return { isApiSuccessful: false, data: err };
  }
}
